// extracted by mini-css-extract-plugin
export var boxItems = "_7z-1";
export var boxItemsLg = "_7z-2";
export var button = "_7z-7";
export var buttonHoverless = "_7z-9";
export var buttonLg = "_7z-8";
export var filterGroupBox = "_7z-0";
export var icon = "_7z-3";
export var iconSecondary = "_7z-6";
export var iconWrapper = "_7z-4";
export var iconWrapperLg = "_7z-5";
export var truncatedLabel = "_7z-a";